<template>
  <form class="validate-form" @submit.prevent="handleSave">
    <div>
      <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
        <BoxIcon />
        <h2 class="text-lg font-medium mr-auto">{{ $t('resource.add') }}</h2>
        <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
          <button
            type="submit"
            class="btn btn-primary shadow-md flex items-center"
          >
            <SaveIcon class="w-4 h-4 mr-2" /> {{ $t('common.save') }}
          </button>
          <router-link
            :to="{ name: 'side-menu-resources' }"
            tag="a"
            class="btn shadow-md flex items-center"
          >
            <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
          </router-link>
        </div>
      </div>
      <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
        <div class="col-span-12">
          <div class="intro-y box p-5">
            <div class="post intro-y overflow-hidden box mt-5">
              <div
                class="
                  post__tabs
                  nav nav-tabs
                  flex-col
                  sm:flex-row
                  bg-gray-300
                  dark:bg-dark-2
                  text-gray-600
                "
                role="tablist"
              >
                <a
                  id="sk-tab"
                  data-toggle="tab"
                  data-target="#sk"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center active"
                  role="tab"
                  aria-controls="sk"
                  aria-selected="true"
                >
                  <country-flag country="sk" size="small" />
                  {{ $t('common.language.sk_SK') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#en"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="en"
                  aria-selected="false"
                >
                  <country-flag country="gb" size="small" />
                  {{ $t('common.language.en_UK') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#cs"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="cs"
                  aria-selected="false"
                >
                  <country-flag country="cz" size="small" />
                  {{ $t('common.language.cs_CZ') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#de"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="de"
                  aria-selected="false"
                >
                  <country-flag country="de" size="small" />
                  {{ $t('common.language.de_DE') }}
                </a>
                <a
                  id="en-tab"
                  data-toggle="tab"
                  data-target="#pl"
                  href="javascript:;"
                  class="flex-1 py-2 rounded-md text-center"
                  role="tab"
                  aria-controls="pl"
                  aria-selected="false"
                >
                  <country-flag country="pl" size="small" />
                  {{ $t('common.language.pl_PL') }}
                </a>
              </div>
              <div class="tab-content">
                <div
                  class="tab-pane active"
                  id="sk"
                  role="tabpanel"
                  aria-labelledby="sk-tab"
                >
                  <div class="mt-3">
                    <label
                      for="nameSk"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="nameSk"
                      v-model.trim="validate.nameSk.$model"
                      type="text"
                      name="nameSk"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{ 'border-theme-6': validate.nameSk.$error }"
                      placeholder="My Place"
                    />
                    <label
                      for="descriptionSk"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionSk"
                      name="descriptionSk"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionSk"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="en"
                  role="tabpanel"
                  aria-labelledby="en-tab"
                >
                  <div class="mt-3">
                    <label
                      for="nameEn"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="nameEn"
                      v-model.trim="validate.nameEn.$model"
                      type="text"
                      name="nameEn"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{ 'border-theme-6': validate.nameEn.$error }"
                      placeholder="My Place"
                    />
                    <label
                      for="descriptionEn"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionEn"
                      name="descriptionEn"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionEn"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="cs"
                  role="tabpanel"
                  aria-labelledby="cs-tab"
                >
                  <div class="mt-3">
                    <label
                      for="nameCs"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="nameCs"
                      v-model.trim="validate.nameCs.$model"
                      type="text"
                      name="nameCs"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{ 'border-theme-6': validate.nameCs.$error }"
                      placeholder="My Place"
                    />
                    <label
                      for="descriptionCs"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionCs"
                      name="descriptionCs"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionCs"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="de"
                  role="tabpanel"
                  aria-labelledby="de-tab"
                >
                  <div class="mt-3">
                    <label
                      for="nameDe"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="nameDe"
                      v-model.trim="validate.nameDe.$model"
                      type="text"
                      name="nameDe"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{ 'border-theme-6': validate.nameDe.$error }"
                      placeholder="My Place"
                    />
                    <label
                      for="descriptionDe"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionDe"
                      name="descriptionDe"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionDe"
                    >
                    </textarea>
                  </div>
                </div>
                <div
                  class="tab-pane"
                  id="pl"
                  role="tabpanel"
                  aria-labelledby="pl-tab"
                >
                  <div class="mt-3">
                    <label
                      for="namePl"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.name') }}
                      <span
                        class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600"
                      >
                        {{ $t('form.required') }},
                        {{ $t('form.constraint.gte2ch') }}
                      </span>
                    </label>
                    <input
                      id="namePl"
                      v-model.trim="validate.namePl.$model"
                      type="text"
                      name="namePl"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      :class="{ 'border-theme-6': validate.namePl.$error }"
                      placeholder="My Place"
                    />
                    <label
                      for="descriptionPl"
                      class="form-label w-full flex flex-col sm:flex-row"
                    >
                      {{ $t('common.description') }}
                    </label>
                    <textarea
                      id="descriptionPl"
                      name="descriptionPl"
                      class="
                        intro-y
                        form-control
                        py-3
                        px-4
                        box
                        pr-10
                        placeholder-theme-13
                      "
                      v-model="descriptionPl"
                    >
                    </textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-3">
              <template v-if="validate.nameSk.$error">
                <div
                  v-for="(error, index) in validate.nameSk.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.nameEn.$error">
                <div
                  v-for="(error, index) in validate.nameEn.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.nameCs.$error">
                <div
                  v-for="(error, index) in validate.nameCs.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.nameDe.$error">
                <div
                  v-for="(error, index) in validate.nameDe.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
              <template v-if="validate.namePl.$error">
                <div
                  v-for="(error, index) in validate.namePl.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <label
                for="internalName"
                class="form-label w-full flex flex-col sm:flex-row"
              >
                {{ $t('form.field.internalName') }},
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.required') }},
                  {{ $t('form.constraint.gte2ch') }}
                </span>
              </label>
              <input
                id="internalName"
                v-model.trim="validate.internalName.$model"
                type="text"
                name="internalName"
                class="
                  intro-y
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                "
                :class="{ 'border-theme-6': validate.internalName.$error }"
              />
              <template v-if="validate.internalName.$error">
                <div
                  v-for="(error, index) in validate.internalName.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <label
                for="capacity"
                class="form-label w-full flex flex-col sm:flex-row"
              >
              {{ $t('common.capacity') }}
                <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                  {{ $t('form.constraint.capacityBlank') }}
                </span>
              </label>
              <input
                id="capacity"
                v-model.trim="validate.capacity.$model"
                type="number"
                name="capacity"
                class="
                  intro-y
                  form-control
                  py-3
                  px-4
                  box
                  pr-10
                  placeholder-theme-13
                "
                :class="{ 'border-theme-6': validate.capacity.$error }"
              />
              <template v-if="validate.capacity.$error">
                <div
                  v-for="(error, index) in validate.capacity.$errors"
                  :key="index"
                  class="text-theme-6 mt-2"
                >
                  {{ $t(error.$message) }}
                </div>
              </template>
            </div>
            <div class="mt-3">
              <BranchMultiselect v-model:selectedBranches="selectedBranches" />
            </div>
            <div class="mt-3">
              <ServiceMultiselect v-model:selectedServices="selectedServices" />
            </div>
            <div class="form-check flex-col items-start mt-3">
              <label for="visible" class="form-check-label ml-0 mb-2">
                {{ $t('common.visibility') }}
              </label>
              <input
                id="visible"
                v-model="validate.visible.$model"
                name="visible"
                class="form-check-switch"
                type="checkbox"
              />
            </div>
            <div class="form-check flex-col items-start mt-3">
              <label for="active" class="form-check-label ml-0 mb-2">
                {{ $t('common.active') }}
              </label>
              <input
                id="active"
                v-model="validate.active.$model"
                name="active"
                class="form-check-switch"
                type="checkbox"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('resource.created') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('resource.notCreated') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref, toRaw, toRefs, reactive } from 'vue'
import { required, minLength, integer, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Toastify from 'toastify-js'
import BranchMultiselect from '../../components/branches/BranchMultiselect.vue'
import ServiceMultiselect from '../../components/services/ServiceMultiselect.vue'
import resourceApi from '../../services/resources/resource.api'
import authHeader from '@/services/security/auth.header'

export default defineComponent({
  components: {
    BranchMultiselect,
    ServiceMultiselect
  },
  methods: {
    handleSave(data) {
      this.loading = true

      this.validate.$touch()
      if (this.validate.$invalid) {
        Toastify({
          node: cash('#failed-notification-content')
            .clone()
            .removeClass('hidden')[0],
          capacity: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.loading = false
        return
      }

      const saveRequest = {
        name: {
          sk_SK: data.target.elements.nameSk.value,
          en_US: data.target.elements.nameEn.value,
          cs_CZ: data.target.elements.nameCs.value,
          de_DE: data.target.elements.nameDe.value,
          pl_PL: data.target.elements.namePl.value
        },
        description: {
          sk_SK: this.descriptionSk,
          en_US: this.descriptionEn,
          cs_CZ: this.descriptionCs,
          de_DE: this.descriptionDe,
          pl_PL: this.descriptionPl
        },
        internalName: data.target.elements.internalName.value,
        capacity:
          data.target.elements.capacity.value === '' || data.target.elements.capacity.value == '0'
            ? null
            : data.target.elements.capacity.value,
        branches: toRaw(this.selectedBranches.selectedBranches) ?? [],
        services: toRaw(this.selectedServices.selectedServices) ?? [],
        active: data.target.elements.active.checked,
        visible: data.target.elements.visible.checked
      }

      resourceApi.createResource(saveRequest).then(
        response => {
          Toastify({
            node: cash('#success-notification-content')
              .clone()
              .removeClass('hidden')[0],
            capacity: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.$router.push({ name: 'side-menu-resources' })
        },
        error => {
          console.log(error)
          Toastify({
            node: cash('#failed-notification-content')
              .clone()
              .removeClass('hidden')[0],
            capacity: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
        }
      )
    }
  },
  computed: {
    console: () => console
  },
  setup() {
    const loading = ref(false)
    const selectedBranches = ref([])
    const selectedServices = ref([])
    const descriptionSk = ref('')
    const descriptionEn = ref('')
    const descriptionCs = ref('')
    const descriptionDe = ref('')
    const descriptionPl = ref('')
    const authHeaderValue = authHeader()

    const formData = reactive({
      nameSk: '',
      nameEn: '',
      nameCs: '',
      nameDe: '',
      namePl: '',
      internalName: '',
      capacity: 0,
      visible: false,
      active: false
    })
    const rules = {
      nameSk: {
        required: helpers.withMessage(
          'form.validation.name_sk.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      nameEn: {
        required: helpers.withMessage(
          'form.validation.name_en.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      nameCs: {
        required: helpers.withMessage(
          'form.validation.name_cs.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      nameDe: {
        required: helpers.withMessage(
          'form.validation.name_de.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      namePl: {
        required: helpers.withMessage(
          'form.validation.name_pl.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      internalName: {
        required: helpers.withMessage(
          'form.validation.internalName.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      capacity: {
        integer
      },
      visible: {},
      active: {}
    }
    const validate = useVuelidate(rules, toRefs(formData))

    return {
      loading,
      validate,
      formData,
      descriptionSk,
      descriptionEn,
      descriptionCs,
      descriptionDe,
      descriptionPl,
      selectedBranches,
      selectedServices,
      authHeaderValue
    }
  }
})
</script>
